import Title from './Title.vue';

export default Title;



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/components/block/components/itemsblock/components/title/index.ts